import { createContext } from 'react';

import type { Modal } from './interface';

export default createContext<Modal[]>([]);
